export default {
    preferences: {
        currentPage: {
            page: 1,
            section: '',
        },
    },
};
